export const DEAL_RENT_TRAP_MAINPAGE = 'deal_rent_trap_mainpage';

export const DESKTOP_HEADER_V2 = 'audience_new_header_v2';

export const AUDIENCE_ONETWOTRIP_BANNER = 'audience_onetwotrip_banner';

export const NEWBUILDING_PROMOS_IN_SEARCH = 'newbuilding_promos_in_search';

export const ADD_FORM_TAB_MAINPAGE = 'spec_addform_on_mainpage';

export const EXPERIMENTS = [
  DEAL_RENT_TRAP_MAINPAGE,
  DESKTOP_HEADER_V2,
  AUDIENCE_ONETWOTRIP_BANNER,
  NEWBUILDING_PROMOS_IN_SEARCH,
  ADD_FORM_TAB_MAINPAGE,
];
